@if (ordersummaryleft?.hideLeftSection=='false') {
  <div class="row orders_rowsection_uk leftviewmob leftbackgradient">
    <div class="row col-xs-12 col-md-12 season_title_uk leftseasontitle">
      {{ordersummaryleft?.leftSectionSeason | seasonspilt}} {{"ukordersummary.seasontxt" | cxTranslate}}
    </div>
    <!-- new chnages start here -->
    <div class=" row orders_rowsectionleft_uk">
      <div class=" orders_rowsection">
        @if (orderrba?.RBAPermissions==true) {
          @if (orderrba?.showDashboardOrderUK==true ) {
            <div class="col-xs-12 orders_newordertitle no-padding">{{"ordersummary.newordertxt" | cxTranslate}}</div>
            <div class="col-xs-12 orders_neworderbox2 ordertooms" data-bs-toggle="modal" data-bs-target="#ordersummary_OM_seasonConfirmPopup" (click)="seasonclick(ordersummaryleft?.leftSectionSeason)">
              <div class="orders_boxtext1">{{"ukordersummary.placeordertxt" | cxTranslate}}</div>
              <div class="orders_boxtext2">
                {{ordersummaryleft?.leftSectionSeason | seasonspilt}} {{"ukordersummary.seasontxt" | cxTranslate}} <i class="orders_global_blackarrow pull-right"></i>
              </div>
            </div>
          }
        } @else {
          <ng-container >
            <div class="col-xs-12 orders_newordertitle no-padding">{{"ordersummary.newordertxt" | cxTranslate}}</div>
            <div class="col-xs-12 orders_neworderbox2 ordertooms" data-bs-toggle="modal" data-bs-target="#ordersummary_OM_seasonConfirmPopup"  (click)="seasonclick(ordersummaryleft?.leftSectionSeason)">
              <div class="orders_boxtext1">{{"ukordersummary.placeordertxt" | cxTranslate}}</div>
              <div class="orders_boxtext2">
                {{ordersummaryleft?.leftSectionSeason | seasonspilt}} {{"ukordersummary.seasontxt" | cxTranslate}} <i class="orders_global_blackarrow pull-right"></i>
              </div>
            </div>
          </ng-container>
        }
      </div>
    </div>
    @if (ordersummaryleft?.season=='Seqirus_InSeason') {
      <div class="form-group col-xs-11 no-padding chartfiltercont">
        <div class="col-md-9 col-lg-9 col-xs-8 no-padding for_tab_view">
          <div class="input-group seach_order">
            <div class="input-group-addon chartsearchicon">
              <i class="fa fa-search"></i>
            </div>
            <input class="form-control" id="chart_searchinput" name="lookup" type="text" (keyup)="inputsearch($event)">
          </div>
        </div>
        <div class="col-md-1 col-xs-2 chartfilterbox" (click)=" filterclickopen()">
          <span class="select_counter">{{filtercount}}</span> <span class="chartfilter_txt">{{"ukordersummary.filterlabel" | cxTranslate}}</span>
        </div>
        <div class="chartfilteropen" [ngClass]="filteropen?'open':''">
          <div class="statussection ">
            <div class="chartfilterheader">
              {{"ukordersummary.byloclabel" | cxTranslate}}
            </div>
            <div class="col-md-12 no-padding dynamicLocations_Chart">
              @for (item of filtertoshow; track item) {
                <label>
                  <input type="checkbox"  #checkboxes class="registration_checkbox" name="locationname" value={{item}} (click)="filtercheck($event,item.deliveryLoc)">
                  <span class="Chart_checkbox-button__control"></span>
                  <span class="filterName">{{item.deliveryLoc}}</span>
                </label>
              }
            </div>
            <div class="invoice_reset" id="Chartorder_resetfilter" (click)="reset()">
              {{"ukordersummary.resetlabel" | cxTranslate}}
            </div>
          </div>
        </div>
        <!--  search lookup start here -->
        <div class="chartsearchopen" [ngClass]="searchtoshow?'open':''">
          @for (seachedData of searched; track seachedData) {
            <div class="searchedtext" (click)="searchedClicked(seachedData.deliveryLoc)"><span class="lookorg">{{seachedData.orgName}}</span>&nbsp;&nbsp; <span class="lookloc">{{seachedData.deliveryLoc}}</span> </div>
          }
        </div>
      </div>
      <!-- chart start here -->
      <div class="row deliverygraph">
        <div class="col-xs-12 orders_graphtitle col-md-8 no-padding-right">{{"ukordersummary.deliveryprogtxt" | cxTranslate}}</div>
        <div class="col-xs-12 col-md-4 order_graph_total">
          {{"ukordersummary.totalorderedtxt" | cxTranslate}}<br>
          <span>{{totalShipped | number:'1.0'}}</span> doses</div>
          <div id="ordergraphcontainer" [chart]="columnChart"></div>
        </div>
        <div class="row col-lg-12 no-padding-right">
          <div class="row orders_rowsection leftlatestdelivery col-lg-12">
            <div class="col-xs-12 col-md-6 orders_latesshipment no-padding margin-T30 float_left">
            {{"ukordersummary.latestdelivtxt" | cxTranslate}}</div>
            <div class="col-xs-12 col-md-6 orders_vieworder float_left">
              <a [routerLink]="'/orders/my-orders'" [queryParams]="{ season : ordersummaryleft?.leftSectionSeason }" class="orders_viewalltxt">{{"ukordersummary.viewopenorder" | cxTranslate}}<i class="global_blackarrow"></i>
            </a>
          </div>
          <div class="col-xs-12 margin-T30 orders_tablepadding_uk no-padding">
            <div class="latest_shipment_uk">
              <table id="deliveryTable" class="tableClass" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="orders">
                  <th mat-header-cell *matHeaderCellDef>{{"ukordersummary.ordernolabel" | cxTranslate}}</th>
                  <td mat-cell class="matRow" *matCellDef="let element">{{element.orders}}</td>
                </ng-container>
                <ng-container matColumnDef="qty">
                  <th mat-header-cell *matHeaderCellDef>{{"ukordersummary.delivdoseslabel" | cxTranslate}}</th>
                  <td mat-cell class="matRow" *matCellDef="let element">{{element.qty | number:'1.0'}}</td>
                </ng-container>
                <ng-container matColumnDef="location">
                  <th mat-header-cell *matHeaderCellDef>{{"ukordersummary.delivloclabel" | cxTranslate}}</th>
                  <td mat-cell class="matRow" *matCellDef="let element"> {{element.location}} </td>
                </ng-container>
                <ng-container matColumnDef="viewdetails">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell class="matRow" *matCellDef="let element"><a class="orders_viewDetails anchorunderline" [routerLink]="'/orders/my-orders'" [queryParams]="{address: element.orders}">{{element.viewdetails}} <i class="global_blackarrow"></i></a> </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell no-data" colspan="4">{{"ukordersummary.nodatatxt" | cxTranslate}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class=" row">
        <div class="col-md-8 orders_rightbottomborder orders_leftseperator"></div>
        <div class="col-md-2 "></div>
      </div>
    } @else {
      <div class="row orders_rowsection leftupcoming no-padding">
        <div class="upcominghead">
          <!-- have to add conditon here for reserve -->
          <!-- provisional changes -->
          <div class="col-xs-12 col-md-6 orders_producttitle no-padding">{{"ukordersummary.upcomingorder" | cxTranslate}}</div>
          <!-- have to add conditon here for reserve -->
          <div class="col-xs-12 col-md-6 orders_vieworder upcomingvieworder rightviewall">
            <a [routerLink]="'/orders/my-orders'" [queryParams]="{ season : ordersummaryleft?.leftSectionSeason }" class="orders_viewalltxt"> {{"ukordersummary.viewopenorder" | cxTranslate}}<i class="global_blackarrow"></i>
          </a>
        </div>
      </div>
      <table mat-table [dataSource]="dataSourceupcoming" matSort class="mat-elevation-z8 filterTable_upcomingOrder">
        <ng-container matColumnDef="combined" >
          <th class="odertableheader" mat-header-cell *matHeaderCellDef> order Data </th>
          <td mat-cell *matCellDef="let element">
            <div class="tablecolum_order1">
              <div class="order_season">{{element.season}} {{"ukordersummary.seasontxt" | cxTranslate}}</div>
              <div class="order_id"><span>{{"ukordersummary.ordernumlabel" | cxTranslate}}</span><span>{{element.orderId}}</span></div>
              <div class="order_id"><span>{{element.displayProduct1}}</span><span class="totalorderquantity_Order" [className]=element.ordernum>{{element.aqivTotal | number:'1.0'}}</span></div>
              <div class="order_id"><span>{{element.displayProduct2}}</span><span class="totalorderquantity_Order" [className]=element.ordernum>{{element.qivcTotal | number:'1.0'}}</span></div>
              <div class="order_id"><span>{{"ukordersummary.delloclabel" | cxTranslate}}</span><span [innerHtml]="element.delLocation"></span></div>
              <div class="upvieworder"><a [routerLink]="'/orders/my-orders'" [queryParams]="{ season : ordersummaryleft?.leftSectionSeason,address:element.orderId }" >{{"ukordersummary.viewordertxt" | cxTranslate}} <i class="global_blackarrow"></i></a></div>
            </div>
            <div class="tablecolum_order2">
              <div class="order_status">{{element.status}}</div></div>
            </td>
          </ng-container>
          <!-- Header and Row Declarations -->
          <tr mat-header-row *matHeaderRowDef="displayedColumnsupcoming"></tr>
          <tr mat-row id="{{row.ordernum}}" *matRowDef="let row; columns: displayedColumnsupcoming;"></tr>
          <tr class="mat-row " *matNoDataRow>
            <td class="mat-cell noorder">{{"ukordersummary.noordertxt" | cxTranslate}}</td>
          </tr>
        </table>
      </div>
    }
    <!-- upcoming order start -->
    <!-- upcoming orders end -->
    <div class="row" >
      <div class="  orders_rowsection orders_rowsectionleft_uk leftproductavaiable">
        <div class="row">
          <div class="col-xs-12 col-md-12 orders_producttitle">{{"ordersummary.productavailablity" | cxTranslate}}</div>
          <div class="col-xs-12 col-md-12 orders_productyear">{{ordersummaryleft?.leftSectionSeason | seasonspilt}}</div>
        </div>
        <div class="col-xs-12 orders_prodbox no-padding">
          <div class="orders_prodtext1" id="orderProduct0" >{{product1}} </div>
          <div class="orders_prodtext2">
            <span>{{product1}} &nbsp;</span><span class="product_avail_pack">({{pack1}})</span>
            @if (ordersummaryleft?.products[0].sellable) {
              <span class="orders_avilabletxt pull-right">{{"ordersummary.availabletxt" | cxTranslate}}</span>
            } @else {
              
              <span class="orders_avilabletxt pull-right product_soldout">
                <div class="soldouttxt unavailableProd">{{"ukordersummary.unavailabletxt" | cxTranslate}}</div>
              </span>
            }
          </div>
        </div>
        <div class="col-xs-12 orders_prodbox no-padding">
          <div class="orders_prodtext1" id="orderProduct1">{{product2}} </div>
          <div class="orders_prodtext2">
            <span>{{product2}} &nbsp;</span><span class="product_avail_pack">({{pack2}})</span>
            @if (ordersummaryleft?.products[1].sellable) {
              <span class="orders_avilabletxt pull-right">{{"ordersummary.availabletxt" | cxTranslate}}</span>
            } @else {
              <span class="orders_avilabletxt pull-right product_soldout">
                <div class="soldouttxt unavailableProd">{{"ukordersummary.unavailabletxt" | cxTranslate}}</div>
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

